import React from 'react';
import { Link } from 'react-router-dom'; // 1. Import Link
import DashboardLayout from '../../components/Layout/DashboardLayout';

// 1. Import your images
//    Adjust the path according to where you've placed them within src/
import mainReservationImage from '../../assets/img/reservation-mexico.png';
import galleryImage1 from '../../assets/img/reservation-mexico.png'; // Assuming same image for gallery for now
import galleryImage2 from '../../assets/img/reservation-mexico.png';
import galleryImage3 from '../../assets/img/reservation-mexico.png';
import galleryImage4 from '../../assets/img/reservation-mexico.png';

// Placeholder data - in a real app, this would come from props or an API
const itineraryData = {
    destination: "Ciudad de México",
    mainImage: mainReservationImage, // 2. Use the imported variable
    galleryImages: [
        galleryImage1, galleryImage2, galleryImage3, galleryImage4 // Use imported variables
    ],
    dateRange: "Abril a 15 Mayo",
    duration: "4 Noches - 5 días",
    peopleCount: "2 personas",
    dailyActivities: [
        {
            id: "day1",
            title: "Día 1 - 3 : Hotel Ciudad de México",
            content: "Check-in en el Hotel Ciudad de México. Disfruta de las instalaciones y descansa del viaje.",
            recommendations: "Actividades recomendadas:",
            galleryLink: "itinerary/1/gallery" // Placeholder for actual link or routing
        },
        {
            id: "day2",
            title: "Día 2 -3 : Tour por la Ciudad",
            content: "Explora los principales puntos turísticos de la ciudad. Visita el Zócalo, la Catedral Metropolitana y el Palacio de Bellas Artes.",
            recommendations: "Actividades recomendadas:",
            galleryLink: "itinerary/2/gallery" // Placeholder for actual link or routing
        }
    ]
};

const ItineraryUserScreen = () => {
    return (
        <DashboardLayout activeMenuItem="Mis Rutas" isScrollable={true}>
            <div className="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pt-3 pb-2">
                <h1 className="h2 mb-4">Viaje soñado a “{itineraryData.destination}”</h1>
            </div>

            <div className="row text-start mb-4">
                <div className="col-12">
                    <div className="card card-metric border-0">
                        <div className="card-body px-md-2 px-0">
                            <div className="row mb-3">
                                <div className="col-md-7 text-start d-md-flex flex-md-column">
                                    <img src={itineraryData.mainImage} className="img-fluid image-reservation w-100 main-featured-image-desktop" alt="Imagen de la reserva" />
                                </div>
                                <div className="col-md-5 text-start">
                                    <div className="image-gallery-grid gap-3">
                                        {itineraryData.galleryImages.map((imgSrc, index) => (
                                            <img key={index} src={imgSrc} className="img-fluid" alt={`Imagen de la galería ${index + 1}`} />
                                        ))}
                                    </div>
                                </div>
                            </div>
                            <div id="reservationDetailsResume" className="row pt-3">
                                <div className="col-12">
                                    <div className="d-flex flex-wrap justify-content-start align-items-center gap-4">
                                        <span className="badge reservation-badge reservation-badge-date">
                                            <i className="bi bi-calendar-event me-2"></i> {/* Added me-2 for spacing */}
                                            <span>{itineraryData.dateRange}</span>
                                        </span>
                                        <span className="badge reservation-badge reservation-badge-duration">
                                            <i className="bi bi-clock-history me-2"></i> {/* Added me-2 for spacing */}
                                            <span>{itineraryData.duration}</span>
                                        </span>
                                        <span className="badge reservation-badge reservation-badge-people-count">
                                            <i className="bi bi-people me-2"></i> {/* Added me-2 for spacing */}
                                            <span>{itineraryData.peopleCount}</span>
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pt-3 pb-2 mb-3">
                <h3 className="mb-2">Tu itinerario por día</h3>
            </div>
            <div className="accordion" id="activitiesAccordion">
                {itineraryData.dailyActivities.map((activity, index) => (
                    <div className="accordion-item" key={activity.id}>
                        <h2 className="accordion-header" id={`heading${activity.id}`}>
                            <button 
                                className={`accordion-button ${index !== 0 ? 'collapsed' : ''}`} 
                                type="button" 
                                data-bs-toggle="collapse" 
                                data-bs-target={`#collapse${activity.id}`} 
                                aria-expanded={index === 0 ? "true" : "false"} 
                                aria-controls={`collapse${activity.id}`}>
                                {activity.title}
                            </button>
                        </h2>
                        <div id={`collapse${activity.id}`} className={`accordion-collapse collapse ${index === 0 ? 'show' : ''}`} aria-labelledby={`heading${activity.id}`} data-bs-parent="#activitiesAccordion">
                            <div className="accordion-body">
                                <p>{activity.content}</p>
                                <p className="mb-2">{activity.recommendations}</p> {/* Added mb-2 for spacing if needed */}
                                <Link to={`/${activity.galleryLink}`} className="btn btn-checkin py-1 px-2 mt-2">Ver Galería</Link> {/* 2. Use Link component */}
                            </div>
                        </div>
                    </div>
                ))}
            </div>
        </DashboardLayout>
    );
};

export default ItineraryUserScreen;